import { sortBy } from "lodash";
import API from "serviceshift-ui/api-client";
import { authenticityToken } from "@/lib/helpers";

import {
  EmailTemplate,
  EmailTemplateCustomization
} from "@/EmailTemplates/emailTemplate";

export default {
  async previewQuoteEmailTemplate(
    _,
    params: {
      customizations: EmailTemplateCustomization[];
      quote: {
        links: {
          quote_email_preview: string;
        };
      };
    }
  ) {
    const request = await API.makeRequest<string>(
      params.quote.links.quote_email_preview,
      {
        method: "POST",
        headers: {
          "X-CSRF-Token": authenticityToken(),
          ignoreError: true
        },
        data: {
          customizations: params.customizations
        }
      }
    );
    return request.data;
  },
  async previewInvoiceEmailTemplate(
    _,
    params: {
      customizations: EmailTemplateCustomization[];
      invoice: {
        links: {
          invoice_email_preview: string;
        };
      };
    }
  ) {
    const request = await API.makeRequest<string>(
      params.invoice.links.invoice_email_preview,
      {
        method: "POST",
        headers: {
          "X-CSRF-Token": authenticityToken(),
          ignoreError: true
        },
        data: {
          customizations: params.customizations
        }
      }
    );
    return request.data;
  },
  async viewQuoteEmailTemplateNoCustomizations(
    _,
    quote: {
      links: {
        quote_email_template: string;
      };
    }
  ) {
    const request = await API.makeRequest<string>(
      quote.links.quote_email_template,
      {
        headers: {
          ignoreError: true
        }
      }
    );
    return request.data;
  },
  async viewInvoiceEmailTemplateNoCustomizations(
    _,
    invoice: {
      links: {
        invoice_email_template: string;
      };
    }
  ) {
    const request = await API.makeRequest<string>(
      invoice.links.invoice_email_template,
      {
        headers: {
          ignoreError: true
        }
      }
    );
    return request.data;
  },
  async fetchEmailTemplates() {
    const emailTemplatesResponse = await API.makeRequest<
      {
        key: string;
        description: string;
        kind: string;
      }[]
    >("/email_templates.json");
    const emailTemplates = (emailTemplatesResponse.data || []).map(
      (email) => new EmailTemplate(email)
    );
    if (emailTemplatesResponse.data.length === 0) {
      throw "No email templates found.";
    }
    return sortBy(emailTemplates, (emailTemplate) => emailTemplate.key);
  },
  async fetchEmailTemplateCustomizations(_, templateKey: string) {
    const customizationsResponse = await API.makeRequest<
      {
        key: string;
        category: string;
        description: string;
        default: string;
        data_type: string;
        value: string;
      }[]
    >(`/email_templates/${templateKey}/customizations.json`);
    return customizationsResponse.data.map(
      (customization) => new EmailTemplateCustomization(customization)
    );
  },
  async saveEmailTemplateCustomization(_, data: EmailTemplateCustomization) {
    await API.makeRequest(`/customizations/${data.key}.json`, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": authenticityToken()
      },
      data: {
        customization: {
          key: data.key,
          value: data.value
        }
      }
    });
  },

  // TODO: We will not need this once we have a bulk save endpoint
  async removeEmailTemplateCustomization(_, data: EmailTemplateCustomization) {
    await API.makeRequest(`/customizations/${data.key}.json`, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": authenticityToken(),
        ignoreError: true
      }
    });
  },
  async sendAdhocEmail() {
    return null;
  },
  async viewEmailTemplateNoCustomizations(_, params: { templateKey: string }) {
    const response = await API.makeRequest<string>(
      `/email_templates/${params.templateKey}`,
      {
        headers: {
          ignoreError: true
        }
      }
    );
    return response.data || "";
  },

  // Note: Any customization left undefined will default to the last saved value, not
  // the original like the save endpoint.
  async previewEmailTemplate(
    _,
    params: {
      templateKey: any;
      customizations?: EmailTemplateCustomization[];
    }
  ) {
    const response = await API.makeRequest<string>(
      `/email_templates/${params.templateKey}/preview`,
      {
        method: "POST",
        headers: {
          "X-CSRF-Token": authenticityToken(),
          ignoreError: true
        },
        data: {
          customizations: params.customizations || []
        }
      }
    );
    let emailContent = response.data || "";
    (params.customizations || []).forEach((customization) => {
      emailContent = emailContent.replaceAll(
        `{{${customization.key}}}`,
        customization.value
      );
    });
    return emailContent;
  }
};
